module.exports = __webpack_public_path__ + "static/stacks-3be5d811e43b789861eb9649696692f1.png";